import {
    useEffect,
    useMemo,
    useState,
} from "react";

import DataTable from "components/table/DataTable";

import {
    getBooks,
    deleteBook,
} from "services/api/bookApi";

import {
    showSuccess,
    showError,
} from "utils/toast";

import {
    bookColumns,
} from "./columns";

import BookModal from "./BookModal";


export default function Books() {

    const [
        books,
        setBooks,
    ] = useState([]);


    const [
        loading,
        setLoading,
    ] = useState(false);


    const [
        page,
        setPage,
    ] = useState(1);


    const [
        search,
        setSearch,
    ] = useState("");


    const [
        status,
        setStatus,
    ] = useState("");


    const [
        pagination,
        setPagination,
    ] = useState({
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0,
    });


    const [
        openModal,
        setOpenModal,
    ] = useState(false);


    const [
        selectedItem,
        setSelectedItem,
    ] = useState(null);


    // =========================================================
    // LOAD
    // =========================================================

    const loadData =
        async () => {

            try {

                setLoading(
                    true
                );


                const response =
                    await getBooks(
                        page,
                        10,
                        search,
                        status
                    );


                console.log(
                    "BOOKS RESPONSE:",
                    response
                );


                const records =
                    response?.data?.books ||
                    [];


                setBooks(
                    Array.isArray(
                        records
                    )
                        ? records
                        : []
                );


                setPagination(
                    response?.data?.pagination ||
                    {}
                );


            } catch (
                error
            ) {

                console.error(
                    "Books loading error:",
                    error
                );


                setBooks(
                    []
                );


                showError(
                    error?.response?.data?.message ||
                    "Unable to load books."
                );

            } finally {

                setLoading(
                    false
                );

            }

        };


    useEffect(
        () => {

            loadData();

        },
        [
            page,
            search,
            status,
        ]
    );


    // =========================================================
    // ADD
    // =========================================================

    const handleAdd =
        () => {

            setSelectedItem(
                null
            );

            setOpenModal(
                true
            );

        };


    // =========================================================
    // EDIT
    // =========================================================

    const handleEdit =
        (item) => {

            setSelectedItem(
                item
            );

            setOpenModal(
                true
            );

        };


    // =========================================================
    // DELETE
    // =========================================================

    const handleDelete =
        async (
            item
        ) => {

            if (
                !window.confirm(
                    `Deactivate "${item.title}"?`
                )
            ) {
                return;
            }


            try {

                await deleteBook(
                    item.id
                );


                showSuccess(
                    "Book deactivated successfully."
                );


                await loadData();

            } catch (
                error
            ) {

                console.error(
                    error
                );


                showError(
                    error?.response?.data?.message ||
                    "Unable to deactivate book."
                );

            }

        };


    // =========================================================
    // COLUMNS
    // =========================================================

    const columns =
        useMemo(
            () =>
                bookColumns({
                    onEdit:
                        handleEdit,

                    onDelete:
                        handleDelete,
                }),
            []
        );


    // =========================================================
    // CLOSE
    // =========================================================

    const closeModal =
        () => {

            setOpenModal(
                false
            );

            setSelectedItem(
                null
            );

        };


    // =========================================================
    // RENDER
    // =========================================================

    return (

        <div
            className="
                mt-5
                space-y-5
            "
        >

            {/* HEADER */}

            <div
                className="
                    flex
                    flex-col
                    gap-4
                    rounded-2xl
                    bg-white
                    p-5
                    shadow-sm
                    md:flex-row
                    md:items-center
                    md:justify-between
                "
            >

                <div>

                    <h1
                        className="
                            text-2xl
                            font-bold
                            text-navy-700
                        "
                    >
                        Books
                    </h1>

                    <p
                        className="
                            mt-1
                            text-sm
                            text-gray-500
                        "
                    >
                        Manage books used for
                        sample distribution.
                    </p>

                </div>


                <button
                    type="button"
                    onClick={
                        handleAdd
                    }
                    className="
                        rounded-xl
                        bg-brand-500
                        px-5
                        py-3
                        text-sm
                        font-semibold
                        text-white
                        hover:bg-brand-600
                    "
                >
                    + Add Book
                </button>

            </div>


            {/* FILTERS */}

            <div
                className="
                    grid
                    grid-cols-1
                    gap-4
                    rounded-2xl
                    bg-white
                    p-4
                    shadow-sm
                    md:grid-cols-2
                "
            >

                <input
                    type="text"
                    value={
                        search
                    }
                    onChange={
                        (e) => {

                            setSearch(
                                e.target.value
                            );

                            setPage(
                                1
                            );

                        }
                    }
                    placeholder="
                        Search title,
                        ISBN,
                        publisher...
                    "
                    className="
                        rounded-xl
                        border
                        border-gray-300
                        px-4
                        py-3
                        text-sm
                        outline-none
                        focus:border-brand-500
                    "
                />


                <select
                    value={
                        status
                    }
                    onChange={
                        (e) => {

                            setStatus(
                                e.target.value
                            );

                            setPage(
                                1
                            );

                        }
                    }
                    className="
                        rounded-xl
                        border
                        border-gray-300
                        bg-white
                        px-4
                        py-3
                        text-sm
                        outline-none
                    "
                >

                    <option value="">
                        All Status
                    </option>

                    <option value="active">
                        Active
                    </option>

                    <option value="inactive">
                        Inactive
                    </option>

                </select>

            </div>


            {/* TABLE */}

            <DataTable
                title="Books"
                columns={
                    columns
                }
                data={
                    books
                }
                loading={
                    loading
                }
                onAdd={
                    handleAdd
                }
                addButtonText="Add Book"
            />


            {/* MODAL */}

            <BookModal

                open={
                    openModal
                }

                item={
                    selectedItem
                }

                onClose={
                    closeModal
                }

                reload={
                    loadData
                }

            />

        </div>
    );
}